import * as types from './mutation_types'

export default {
  [types.THUMBNAIL_CREATE_SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.THUMBNAIL_CREATE_SET_LOADING] (state, isLoading) {
    Object.assign(state, { isLoading })
  },

  [types.THUMBNAIL_CREATE_SET_CREATED] (state, created) {
    Object.assign(state, { created })
  },

  [types.THUMBNAIL_CREATE_SET_VIOLATIONS] (state, violations) {
    Object.assign(state, { violations })
  },

  [types.THUMBNAIL_CREATE_RESET] (state) {
    Object.assign(state, {
      created: null,
      error: '',
      isLoading: false,
      violations: null
    })
  }
}
